module.exports = __webpack_public_path__ + "img/map_whole.ae4e26cf.png";